/* Copyright Levelise Ltd 2019-2026 */
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AdminProvider } from './contexts/AdminContext';
import { UserProvider } from './contexts/UserContext';
import { FleetProvider } from './contexts/FleetContext';
import App from './components/App/App';
import './assets/fonts/Inter-Bold.ttf';
import './assets/fonts/Inter-Medium.ttf';
import './assets/fonts/Inter-Light.ttf';
import './index.css';

import { FleetStatusProvider } from './contexts/FleetStatusContext';
import { FleetCustomersProvider } from './contexts/FleetCustomersContext';
import { OrdersProvider } from './contexts/OrdersContext';
import { AlertProvider } from './components/Alert';

const root = createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter>
		<AdminProvider>
			<UserProvider>
				<FleetProvider>
					<FleetStatusProvider>
						<FleetCustomersProvider>
							<OrdersProvider>
								<AlertProvider>
									<App />
								</AlertProvider>
							</OrdersProvider>
						</FleetCustomersProvider>
					</FleetStatusProvider>
				</FleetProvider>
			</UserProvider>
		</AdminProvider>
	</BrowserRouter>,
);
